import type { Job, JobAddress } from "@/data/types";

/** Format full address string from structured fields */
export function formatAddress(addr: JobAddress): string {
  const street = String(addr?.street ?? "").trim();
  const city = String(addr?.city ?? "").trim();
  const state = String(addr?.state ?? "").trim();
  const zip = String(addr?.zip ?? "").trim();

  const cityStateZip = [city, [state, zip].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const full = [street, cityStateZip].filter(Boolean).join(", ");
  return full || "—";
}

/** Get full formatted address from a job */
export function getJobAddress(job: Pick<Job, "address">): string {
  return formatAddress(job.address);
}

/** Get city from job */
export function getJobCity(job: Pick<Job, "address">): string {
  return job.address.city;
}

/** Get street from job */
export function getJobStreet(job: Pick<Job, "address">): string {
  return job.address.street;
}

/** Create a JobAddress from individual fields */
export function makeAddress(street: string, city: string, state = "FL", zip = ""): JobAddress {
  return { street, city, state, zip };
}
